import { gql } from '@apollo/client'

export const PLAYBOOK_FRAGMENT = gql`
  fragment PlaybookFragment on ScoPlaybook {
    id
    color
    slug
    title
    teaser
    tldr
    learningPoints
    illustration
    sections {
      id
      badge
      illustration
      slug
      title
      teaser
      pages {
        id
        title
        content
      }
    }
    topic {
      colorHexCode
    }
  }
`
